import { forwardRef, type InputHTMLAttributes } from 'react'

import { cn } from '../cn'
import { controlClass } from '../primitives/input'
import { useFieldContext } from '../primitives/form-field'

/**
 * Money as text (FRONTEND_PLAN rule 11): the value is the decimal STRING the API expects. Callers
 * canonicalise with `normaliseMoney` on submit; the field itself never parses to a number.
 */
export const MoneyField = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'inputMode'> & {
    readonly currencySymbol?: string
  }
>(function MoneyField({ currencySymbol = '$', className, ...props }, ref) {
  const field = useFieldContext()
  return (
    <div className="relative">
      <span
        aria-hidden
        className="pointer-events-none absolute inset-y-0 left-3 flex items-center text-[13px] text-muted"
      >
        {currencySymbol}
      </span>
      <input
        ref={ref}
        type="text"
        inputMode="decimal"
        placeholder="0.00"
        id={props.id ?? field?.id}
        aria-describedby={field?.describedBy}
        aria-invalid={field?.invalid ? true : undefined}
        {...props}
        className={cn(controlClass, 'h-9 pl-7 font-mono', className)}
      />
    </div>
  )
})
